import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { checkoutTranslationChunksConfig, checkoutTranslationsEn } from '@spartacus/checkout/base/assets';
import { provideConfig } from '@spartacus/core';
import { FormErrorsModule } from '@spartacus/storefront';
import { KnBrMessageDialogModule } from '../common/kn-br-message-dialog/kn-br-message-dialog.module';
import { CwtCheckoutDeliveryAddressModule } from './base/components/cwt-checkout-delivery-address/cwt-checkout-delivery-address.module';
import { CwtCheckoutInstructionsModule } from './base/components/cwt-checkout-instructions/cwt-checkout-instructions.module';

@NgModule({
  imports: [
    CwtCheckoutDeliveryAddressModule,
    CwtCheckoutInstructionsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    KnBrMessageDialogModule,
    FormErrorsModule
],
  providers: [
    provideConfig({
      i18n: {
        resources: checkoutTranslationsEn,
        chunks: checkoutTranslationChunksConfig,
      },
    }),
  ]
})
export class KnBrCheckoutModule { }
